import axios from "axios";
import {get, post} from "../utils/api/api";

const apiUrl = process.env.BACKEND_HOST;

// const apiUrl = 'https://240000-231206.dev.peppers-studio.ru/api/v1/';

export async function getAnalytics() {
  try {
    const {data: {data}} = await axios({
      url: "https://zites.ppprs.ru/api/v1/open/analytics?id=40&token=wiqM4wb1S_RD_rPMWaKSvZBxbcKec9uP"
    })
    return data;
  } catch (error) {
    console.error('ANALYTIC-ERROR:', error)
    return {}
  }
}

export const addMainHeader = (data) => {
  data.headings.unshift({title: "Главная", href: '/'})
  return data;
}

export async function getPageData(id, limit) {
  const [header, content, podcasts, narratives, authorsContent, jackpot, settings, main] = await Promise.all([
    getHeader(),
    getContent(id, limit),
    getPodcast(),
    getNarratives(),
    getAuthors({slug: false}),
    getJackpot(),
    getSettings(),
    getMain(),
  ]);
  return {content, header, podcasts, narratives, authorsContent, jackpot, settings, main};
}

export async function getHoroscopePageData(limit = 12) {
  const [header, content, narratives] = await Promise.all([
    getHeader(),
    getContent('goroskop', limit),
    getNarratives(),
  ]);
  return {header, content, narratives};
}

export async function getHoroscopeIdentifiers() {
  const {tabs} = await getHoroscope();
  const items = [
    ...(tabs?.day || []),
    ...(tabs?.week || []),
    ...(tabs?.month || []),
    ...(tabs?.year || []),
    ...(tabs?.zodiacs || []),
  ];
  const identifiers = new Set(
    items
      .map((item) => item?.href?.split('/').filter(Boolean).pop())
      .filter(Boolean)
  );
  identifiers.add('prediction');
  return [...identifiers];
}

export function getSettings() {
  return get(`${apiUrl}site/index`)
}

export function getMain() {
  return get(`${apiUrl}site/main`)
}

export async function getHoroscope(identifier = false) {
  const {horoscope} = identifier ? await get(`${apiUrl}horoscope/view?identifier=${identifier === 'prediction' ? 'today' : identifier}`) : {}
  const tabs = await get(!horoscope?.zodiacSign ? `${apiUrl}horoscope` : `${apiUrl}horoscope?zodiac=${horoscope?.zodiacSign.slug}`)
  return {horoscope, tabs}
}

export function getContent(id, limit = 17) {
  return get(`${apiUrl}post/index?${id ? `selectedHeadings[]=${id}&` : ''}limit=${limit}`)
}

export function addView({type, identifier}) {
  return post(`${apiUrl}post/add-view?id=${identifier}&type=${type}`, {})
}

export function getNarratives() {
  return get(`${apiUrl}post/narratives`)
}

export function getHeader() {
  return get(`${apiUrl}heading/index`).then(addMainHeader)
}

export function getPodcast() {
  return get(`${apiUrl}post/podcasts`)
}


export function getMoreArticles({page, recordsCount = 17}) {
  return get(`${apiUrl}post/index?${page ? `selectedHeadings[]=${page}&` : ''}offset=${recordsCount}&limit=6`)
}

export async function getContentPage({type, identifier}) {
  const data = await getDataPage({type, identifier});
  const comments = await getComments({type, identifier})
  const authors = await getAuthorsAll();
  return {data, comments, authors}
}

export async function getAuthorsPage({slug, page = 1, heading}) {
  const content = await getAuthors({slug, page, heading});
  const info = await getAuthorsInfo(slug)
  return {content, info}
}

export function getAuthorsAll() {
  return get(`${apiUrl}author/index`)
}

export function getComments({type, identifier, pageCount = 1}) {
  return get(`${apiUrl}post/comments?id=${identifier}&type=${type}&page=${pageCount}&sort=-created_at`)
}

export function getAuthors({slug = false, page = 1, heading = false}) {
  return get(`${apiUrl}post/author?${slug ? 'author.slug=' + slug : ''}&page=${page}${heading ? '&selectedHeadings[]=' + heading : ''}`);
}

export function getDataPage({type, identifier}) {
  return get(`${apiUrl}post/view?id=${identifier}&type=${type}`)
}

export function getJackpot() {
  return get(`${apiUrl}jackpot/index`)
}

export function createComment({type, identifier, text}) {
  return post(`${apiUrl}post/add-comment?id=${identifier}&type=${type}`, {text})
}

export function addLike(id) {
  return post(`${apiUrl}post/like-comment?id=${id}`);
}

export function getAuthorsInfo(slug) {
  return get(`${apiUrl}post/author-details?id=${slug}`)
}

export function getSearch({query, page = 1}) {
  return get(`${apiUrl}post/search?query=${query}&page=${page}`)
}

